import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import Hint from '@components/basics/hint';
import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';

interface PromptHintProps {
  className?: string;
  title: React.ReactNode;
  text?: React.ReactNode;
  action?: React.ReactNode;
  isError?: boolean;
  onClick?: () => void;
}

const PromptHint: FunctionComponent<PromptHintProps> = ({
  className,
  title,
  text,
  action,
  isError,
  onClick,
}) => {
  return (
    <Hint
      className={className || ''}
      noTitle
      error={isError}
      customContent={
        <Flex justifyContent="space-between" alignItems="center" gap={20}>
          <InfoWrapper
            className={`${!action ? 'no-action' : ''} ${
              isError ? 'error' : ''
            }`}
          >
            <Typography className="title" weight="700">
              {title}
            </Typography>
            {text && (
              <Typography type="small" className="text">
                {text}
              </Typography>
            )}
          </InfoWrapper>
          {action && (
            <Link
              className={isError ? 'disabled' : ''}
              weight="700"
              onClick={action ? onClick : undefined}
            >
              {action}
            </Link>
          )}
        </Flex>
      }
    />
  );
};

export default styled(PromptHint)`
  border-radius: 10px;
  padding: 15px;
  @media ${({ theme }) => theme.device.tablet} {
    padding: 30px;
  }
`;

const InfoWrapper = styled.div`
  text-align: left;
  display: grid;
  grid-gap: 5px;
  max-width: calc(100% - 112px);

  &.no-action {
    max-width: none;
    grid-gap: 0;
  }

  .title,
  .text {
    color: ${({ theme }) => theme.colors.black};
  }

  &.error {
    .title {
      color: ${({ theme }) => theme.colors.accent};
    }
  }
`;

const Link = styled(Typography)`
  cursor: pointer;
  opacity: 1;
  transition: opacity
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    opacity: 0.75;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;
